import { render, staticRenderFns } from "./DeviceStatusTable.vue?vue&type=template&id=47675267&scoped=true"
import script from "./DeviceStatusTable.vue?vue&type=script&lang=js"
export * from "./DeviceStatusTable.vue?vue&type=script&lang=js"
import style0 from "./DeviceStatusTable.vue?vue&type=style&index=0&id=47675267&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47675267",
  null
  
)

export default component.exports